<template>
  <div class="loader">
    <h1 class="loader__title">
      Pomóż pszczołom i odbierz Pakiet Pszczelego Bohatera :)
    </h1>
    <div>
      <img
        class="loader__bee"
        src="@/assets/images/i_bee-times.svg"
        alt="pszczoła"
      />
      <img
        class="loader__bee loader__bee--2"
        src="@/assets/images/i_bee-times.svg"
        alt="pszczoła"
      />
      <img
        class="loader__bee loader__bee--3"
        src="@/assets/images/i_bee-times.svg"
        alt="pszczoła"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9999999;
  background-color: rgba(255, 197, 1, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__title {
    font-family: 'Paytone One',"Gothic", "Helvetica", "Consolas", "Arial", sans-serif;
    color: #000;

    font-size: 2rem;
    margin: 1.5rem auto;
    text-align: center;
    text-transform: uppercase;
    @media (max-width: 1600px) {
      padding-inline: 1rem;
    }

    @media (min-width: 1600px) {
      font-size: 2rem;
      font-weight: 400;
      margin-bottom: 2rem;
    }
  }
    &__bee {
    animation: bee_opacity 1.4s infinite;
    animation-fill-mode: both;
    margin-right: 0.5rem;

    &--2 {
      animation-delay: 0.2s;
    }
    &--3 {
      animation-delay: 0.4s;
    }
  }
  @keyframes bee_opacity {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
}
</style>
